<app-top-nav></app-top-nav>
<app-impersonation-notice></app-impersonation-notice>
<router-outlet></router-outlet>
<app-toasts-message aria-live="polite" aria-atomic="true"></app-toasts-message>
<app-impersonation-request></app-impersonation-request>
<app-visitor-counter></app-visitor-counter>